import { connect } from 'react-redux';
import { getIsAdmin } from 'src/store/client/selectors';
import SearcherOperators from '../../components/Searcher/SearcherOperators';
import { getMatchedOperators } from '../../store/selectors/operators';

const mapStateToProps = (state) => ({
  items: getIsAdmin(state) ? getMatchedOperators(state) : null,
});

export default connect(mapStateToProps)(SearcherOperators);
